exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".authorization-modal-button :first-child {\n  height: auto;\n}", ""]);

// exports
